import { useState } from 'react'
import { Button, Typography } from '@material-ui/core'
import { send_command } from '../../components/api'
import { getApiErrorMessage } from 'utils/getApiErrorMessage'
import { formatUtcTimestamp } from 'utils/formatUtcTimestamp'

export const ClientLogs = ({ tenant_id }) => {
    const [logs, setLogs] = useState('')
    const [logsReceived, setLogsReceived] = useState(null)
    const [error, setError] = useState(null)
    const [notice, setNotice] = useState(null)

    const latest_logs = () => {
        send_command('ADMIN_GET_LATEST_CLIENT_LOGS', { tenant_id })
            .then(res => {
                setLogsReceived(formatUtcTimestamp(res.collected_datetime))
                setLogs(JSON.parse(res.logs)[0])
                setError(null)
                setNotice(null)
            })
            .catch(ex => {
                if (ex.message === 'Request failed with status code 404') {
                    setLogs('No logs found')
                    setLogsReceived('None')
                    setError(null)
                    return
                }
                setError(getApiErrorMessage(ex, 'Failed to load latest logs'))
            })
    }

    const fetch_logs = () => {
        send_command('ADMIN_GET_CLIENT_LOGS', { tenant_id })
            .then(() => {
                setNotice('Log fetch command sent to client')
                setError(null)
            })
            .catch(ex => {
                setError(getApiErrorMessage(ex, 'Failed to request logs'))
            })
    }

    return (
        <div className="superadmin-client-logs">
            <Typography variant="body2" color="textSecondary" className="superadmin-client-logs__meta">
                Last received: {logsReceived ?? '—'}
            </Typography>

            <div className="superadmin-client-logs__viewer">
                <pre>{logs || 'No logs loaded yet.'}</pre>
            </div>

            <div className="superadmin-toolbar">
                <Button variant="outlined" size="small" onClick={fetch_logs}>Request logs</Button>
                <Button variant="contained" color="primary" size="small" onClick={latest_logs}>Latest logs</Button>
            </div>

            {notice && (
                <Typography variant="body2" color="textSecondary" className="superadmin-muted-note">
                    {notice}
                </Typography>
            )}
            {error && (
                <Typography variant="body2" color="error" className="superadmin-muted-note">
                    {error}
                </Typography>
            )}
        </div>
    )
}
